/**
 * Returns a boolean indicating whether the given object is empty
 * @function
 * @param {any} obj - The object to check for emptiness.
 * @returns {boolean} - true if the object is empty, false otherwise.
 */
export const isEmpty = (obj: any) =>
  [Object, Array].includes((obj || {}).constructor) &&
  !Object.entries(obj || {}).length
